import React, { useState, useMemo } from 'react';

interface LogoProps {
  variant?: 'colorful' | 'white';
  size?: number;
  className?: string;
}

const InlineLogo = ({ size, className }: { size: number; className?: string }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect x="10" y="10" width="15" height="80" rx="7.5" fill="#0F4D3F" />
    <rect x="75" y="10" width="15" height="80" rx="7.5" fill="#0F4D3F" />
    <rect x="25" y="42.5" width="50" height="15" rx="7.5" fill="#0F4D3F" />
  </svg>
);

const Logo: React.FC<LogoProps> = ({ variant = 'colorful', size = 40, className = '' }) => {
  const [pathIndex, setPathIndex] = useState(0);
  const paths = useMemo(() => (
    variant === 'white'
      ? [
          '/White Logo PNG.png',
          '/Logowhite.svg',
          '/logo-white.svg',
          '/logo_white.svg'
        ]
      : [
          '/Black Logo PNG.png',
          '/Logoblack.svg',
          '/logo.svg',
          '/logo-black.svg'
        ]
  ), [variant]);

  const src = paths[Math.min(pathIndex, paths.length - 1)];

  if (pathIndex >= paths.length) {
    return <InlineLogo size={size} className={className} />;
  }

  return (
    <img
      src={src}
      alt="halr logo"
      width={size}
      height={size}
      className={className}
      onError={() => setPathIndex((i) => i + 1)}
      style={{ display: 'inline-block' }}
    />
  );
};

export default Logo; 